import type { IssueData } from './types';

export const MAX_AGE = 1000 * 60 * 60; // 60 minutes

export const isValidIssueData = (issueData?: IssueData) =>
	!!(issueData && issueData.savedAt > Date.now() - MAX_AGE);
